import moment from "moment";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import { DATE_FORMATS, LOOM_API_KEY } from "../constants";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

export default function RecordButtonHeader({ locals, BUTTON_ID }) {
  const { t } = useTranslation("coaching-portal");
  const { query } = locals;

  useEffect(() => {
    async function setupLoom() {
      // Loom SDK is ~large and browser-only — load it on demand so it stays out
      // of the main bundle.
      const { isSupported } = await import("@loomhq/record-sdk/is-supported");
      const { supported } = await isSupported();

      const button = document.getElementById(BUTTON_ID);

      if (!button) {
        return;
      }

      if (!supported) {
        button.addEventListener("click", (e) => {
          alert(t("recordButtonHeader.incompatibleBrowser"));
        });
        return;
      }

      const { setup } = await import("@loomhq/record-sdk");
      const { configureButton } = await setup({
        publicAppId: LOOM_API_KEY,
      });

      const sdkButton = configureButton({ element: button });

      sdkButton.on("insert-click", async (shareLink) => {
        const date = moment().format(DATE_DAY_FORMAT);

        console.log({ shareLink });

        submit("/actions/exercise/edit-video-record", {
          method: "POST",
          body: {
            date,
            shareLink,
            athleteId: query.athlete,
            _id: null,
            type: "general",
          },
        });
      });
    }

    setupLoom();
  }, [query]);

  return (
    <button id={BUTTON_ID} data-button-type="secondary">
      <img src="/img/icons/loom-record.svg" className="h-4 w-4 mr-2" />
      <span>{t("recordButtonHeader.recordVideo")}</span>
    </button>
  );
}
